import { render, staticRenderFns } from "./FormSlider.vue?vue&type=template&id=6cb3e711&scoped=true&"
import script from "./FormSlider.vue?vue&type=script&lang=ts&"
export * from "./FormSlider.vue?vue&type=script&lang=ts&"
import style0 from "./FormSlider.vue?vue&type=style&index=0&id=6cb3e711&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb3e711",
  null
  
)

export default component.exports